import { useMutation } from '@tanstack/react-query';
import { POST, POST_SUBMIT_INCENTIVE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { InsertIncentive } from '../../../resources/payload';

export const useSubmitIncentive = ({ reset, getValues }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsertIncentive(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });
      const response = await POST(POST_SUBMIT_INCENTIVE(), formData);
      return response;
    },
    onSuccess: (data) => {
      openAlert({
        model: 'message',
        type: 'success',
        message: data?.message,
      });
      reset({
        employeeId: getValues('employeeId'),
        branchId: getValues('branchId'),
        branchName: getValues('branchName'),
        barcodeValue: '',
        priceBill: '',
        slipImage: [],
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
    },
  });

  return {
    mutate,
    isPending,
  };
};
